import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';


import { OfflineApartamentoRegime } from '../../model';

import { API, ITENSPORPAGINA } from '../../app.config';
import { CLIENT_ID } from '../../app.config';

@Injectable()
export class OfflineApartamentoRegimeService{
  constructor(
    private http: HttpClient,
    private router: Router){}


    buscarPorParametro(param: string, pagina: Number,itensPagina: number = 0): Observable<any>{
      const headers = new HttpHeaders().set('noloader', 't');
    itensPagina = itensPagina == 0 ? ITENSPORPAGINA : itensPagina;

      if (param.length > 0){
        return this.http.get<any>( `${API}/api/OfflineApartamentoRegime/list/${param.trim()}?Pagina=${pagina}&ItensPorPagina=${itensPagina}`, {headers: headers});
      }else{
        return this.http.get<any>( `${API}/api/OfflineApartamentoRegime?Pagina=${pagina}&ItensPorPagina=${itensPagina}`, {headers: headers});
      }
    }

    buscarPorId(id: number): Observable<any>{
        return this.http.get<any>( `${API}/api/OfflineApartamentoRegime/${id}?Pagina=1&ItensPorPagina=${ITENSPORPAGINA}`);
    }

    remover(id: Number): Observable<any>{
      return this.http.delete<any>( `${API}/api/OfflineApartamentoRegime/${id}`);
    }

    salvar(offlineApartamentoRegime: OfflineApartamentoRegime): Observable<any>{
      if (offlineApartamentoRegime.Id > 0){
        return this.http.put<any>( `${API}/api/OfflineApartamentoRegime/${offlineApartamentoRegime.Id}`, offlineApartamentoRegime);
      }else{
        return this.http.post<any>( `${API}/api/OfflineApartamentoRegime/`, offlineApartamentoRegime);
      }

    }


  }
